/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ./WritableStream (ignored)
// module id = 4
// module chunks = main